import { Stack } from "@/Components/v2/atoms/Stack";

import { MetricCard, MetricCardProps } from "../../atoms/MetricCard/MetricCard";

export type MetricCardsProps = {
  metrics: MetricCardProps[];
};

export const MetricCards = ({ metrics }: MetricCardsProps) => (
  <Stack direction="row" gap={2} width="100%">
    {metrics.map((metric, index) => (
      <MetricCard key={index} {...metric} />
    ))}
  </Stack>
);
